<template>
  <div>
    <ReflectIconButton
      icon="icon-normalization"
      @click="isMenuOpen = true"
    />
  </div>
  <Teleport
    v-if="isMenuOpen"
    to="#action"
  >
    <SettingsDataQualityModal
      :normalization-fields="normalizationFields"
      :date-range="dateRange"
      @close-modal="isMenuOpen = false"
    />
  </Teleport>
</template>

<script lang="ts">
import type { NormalizedFieldEntry } from '~/types/sourceValue'
import type { DateRange } from '~/types/timeDimension'

export default {
  name: 'NormalizationCheckButton',
  props: {
    normalizationFields: {
      type: Object as PropType<NormalizedFieldEntry[]>,
      required: true
    },
    dateRange: {
      type: Object as PropType<DateRange>,
      required: true
    }
  },
  data(): {
    isMenuOpen: boolean
  } {
    return { isMenuOpen: false }
  }
}
</script>
